import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const selectAuditoriaState = (state: RootState) => state.secretariaArbitralAuditoria;

export const selectAuditoriaItens = (state: RootState) => state.secretariaArbitralAuditoria.items;

export const selectAuditoriaTotal = (state: RootState) => state.secretariaArbitralAuditoria.total;

export const selectAuditoriaPagina = (state: RootState) => state.secretariaArbitralAuditoria.page;

export const selectAuditoriaLimite = (state: RootState) => state.secretariaArbitralAuditoria.limit;

export const selectAuditoriaFiltros = (state: RootState) =>
  state.secretariaArbitralAuditoria.filtros;

export const selectAuditoriaUsuarios = (state: RootState) =>
  state.secretariaArbitralAuditoria.usuariosDisponiveis;

export const selectAuditoriaCarregando = (state: RootState) =>
  state.secretariaArbitralAuditoria.isLoading;

export const selectAuditoriaErro = (state: RootState) => state.secretariaArbitralAuditoria.error;

export const selectAuditoriaTotalPaginas = createSelector([selectAuditoriaState], (auditoria) =>
  Math.max(1, Math.ceil(auditoria.total / Math.max(1, auditoria.limit))),
);

export const selectAuditoriaTemFiltroAtivo = createSelector([selectAuditoriaFiltros], (filtros) =>
  Boolean(
    filtros.busca?.trim() ||
    filtros.categoria?.length ||
    filtros.tipoAcao?.length ||
    filtros.usuarioId ||
    filtros.de ||
    filtros.ate,
  ),
);
